import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { observer } from "mobx-react-lite";

import { useLabel } from "@mr-portfolio-infrastructure/translations/use-label";
import { type CurrencyCode, currencyCodes } from "@mr-portfolio-models/currency";
import { useStores } from "@mr-portfolio-store/use-stores";

export const CurrencyToggle = observer(function CurrencyToggle(): React.JSX.Element {
  const { settingsStore } = useStores();
  const getLabel = useLabel();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={settingsStore.displayCurrency}
      aria-label={getLabel("currency.displayCurrency")}
      onChange={(_event, selectedCurrency: CurrencyCode | null) => {
        if (selectedCurrency !== null) {
          settingsStore.setDisplayCurrency(selectedCurrency);
        }
      }}
    >
      {currencyCodes.map((currency) => (
        <ToggleButton key={currency} value={currency}>
          {currency}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
});
